export enum AD_ROLE {
	AG_MOBI_ADMIN = 'AG MOBI Admins',
	PCM_MOBI_ADMIN = 'PCM MOBI Admins',
	UK_MOBILITY_ADMIN = 'UK MOBILITY ADMINS',
	US_TSM = 'MDM_US',
	UK_TSM = 'MDM_UK',
	JS_TSM = 'MDM_JS'
}

export enum COUNTRY_CD {
	// US Countries
	US = 'US',
	CA = 'CA',
	// UK Countries
	UK = 'UK',
	IR = 'IR',
	// JS Countries
	AU = 'AU',
	NZ = 'NZ',
	// Other
	OTHER = 'OTHER'
}

export const MDM_ADMINS_ROLES = [
	AD_ROLE.AG_MOBI_ADMIN,
	AD_ROLE.PCM_MOBI_ADMIN,
	AD_ROLE.UK_MOBILITY_ADMIN
];

export const TSM_ROLES = [
	AD_ROLE.US_TSM,
	AD_ROLE.UK_TSM,
	AD_ROLE.JS_TSM
];

export const COUNTRY_ROLE_MAP: { [key: string]: string[] } = {
	'US': [AD_ROLE.US_TSM, ...MDM_ADMINS_ROLES],
	'CA': [AD_ROLE.US_TSM, ...MDM_ADMINS_ROLES],
	'UK': [AD_ROLE.UK_TSM, ...MDM_ADMINS_ROLES],
	'IR': [AD_ROLE.UK_TSM, ...MDM_ADMINS_ROLES],
	'AU': [AD_ROLE.JS_TSM, ...MDM_ADMINS_ROLES],
	'NZ': [AD_ROLE.JS_TSM, ...MDM_ADMINS_ROLES],
	'OTHER': [AD_ROLE.US_TSM, ...MDM_ADMINS_ROLES],
}

